export default "__VITE_ASSET__DStLZrA0__"